import React from "react";
import { Typography, Container, Grid, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import img11 from "./assets/11.png";
import img12 from "./assets/12.png";
import img13 from "./assets/13.png";
import img14 from "./assets/14.png";
import img15 from "./assets/15.png";
import img16 from "./assets/16.png";
import img17 from "./assets/17.png";
import img18 from "./assets/18.png";

function Opinion() {
  const images = [img11, img12, img13, img14, img15, img16, img17, img18];

  return (
    <Container maxWidth="lg">
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Perspectives
        </Typography>
        <Typography variant="body1">
          Personal Opinions on the Latest AI Trends and Technologies Affecting the Enterprise
        </Typography>
        <hr />
        <br />
        <br />
        <Typography variant="h5" component="h2" gutterBottom>
          <Grid container spacing={4}>
            {[
              { title: "The Paradox of AI Adoption: Resistance Versus the 10x Potential", path: "/ai-paradox" },
              { title: "Navigating a Rapidly Evolving Industry: Key Considerations for Cloud Architects and Engineers When Selecting AI Tools", path: "/ai-tools" },
              { title: "AI & The Ignorance Tax: An Overview", path: "/ignorance-tax" },
              { title: "The Limits of Inspiration: Motivation Can Be Fueled, But Not Taught", path: "/inspiration-limits" },
              { title: "Harnessing the Momentum of Success: The Natural Law of Winning Streaks", path: "/momentum" },
              { title: "The Divine Departure: ChatGPT's Shutdown and the Spiritual Crisis for AI Believers", path: "/ai-shutdown" },
              { title: "Introducing Robologic Codespace Template: Streamlining Your Development Workflow", path: "/codespace-template" },
              { title: "Embracing Continuous Dependency Updating for Enhanced CI/CD Practices", path: "/cdu" },
            ].map((item, index) => (
              <Grid key={index} item xs={12} sm={6} md={4}>
                <Box mb={2}>
                  <Link to={item.path} style={{ textDecoration: "none" }}>
                    <img
                      src={images[index]}
                      alt={`Placeholder ${index + 11}`}
                      width="100%"
                      style={{ marginBottom: "1rem", borderRadius: "5px" }} />
                    <Button variant="outlined" fullWidth>
                      {item.title}
                    </Button>
                  </Link>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Typography>
      </Box>
    </Container>
  );
}

export default Opinion;
